/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import { VlogSectionHeading } from "@modules/study/common/vlog";
import React, { useEffect, useState } from "react";
// import ReactPlayer from "react-player";
import {
  AiFillLike,
  AiFillDislike,
  AiOutlineLike,
  AiOutlineDislike,
} from "react-icons/ai";
import { RiShareForwardFill } from "react-icons/ri";
import { BsThreeDotsVertical } from "react-icons/bs";
import styles from "./vlog_details.module.scss";
import { Grid, IconButton } from "@mui/material";
import dynamic from "next/dynamic";
import Link from "next/link";
import moment from "moment";
import { getAssets, htmlParse } from "@unisearch/helpers";
const baseUrl = process.env.NEXT_PUBLIC_URL;

const VlogComment = dynamic(
  () => import("@modules/study/vlog/vlog_comment/vlog_comment"),
  {
    ssr: false,
  }
);
const ReactPlayer = dynamic(() => import("react-player"), {
  ssr: false,
});
import API from "@unisearch/helpers/api";
import { useRouter } from "next/router";
import { useRecoilValue } from "recoil";
import { authAtom } from "@_recoil/_state";
import { useSystemActions } from "@_recoil/_actions";
import VlogRecommended from "../components/recommended";
import SocialSharingLinks from "@modules/study/common/social_sharing_links";
import { BiLike } from "react-icons/bi";

export const VlogDetails = ({ vlogDetails, recomendedVideo }) => {
  const keyword = vlogDetails?.primaryCategory?.slug;
  const router = useRouter();
  const profileInfos = useRecoilValue(authAtom);
  const systemAction = useSystemActions();
  const { vlog_slug } = router.query;
  const [like, setLike] = useState(false);
  const [disLike, setDisLike] = useState(false);
  const [countLike, setCountLike] = useState();
  const [profileInfo, setprofileInfo] = useState();
  const [systemActions, setSystemActions] = useState();

  const getData = async () => {
    await API.get(`/public/vlog/user/like-dislike?vlogSlug=${vlog_slug}`).then(
      (res) => {
        if (!res.error && res.data) {
          const { user } = res.data;
          setCountLike(res.data);
          if (user?.likeStatus === 1) {
            setLike(true);
          } else if (user?.dislikeStatus === 1) {
            setDisLike(true);
          }
        }
      }
    );
  };
  const getGuestData = async () => {
    await API.get(`/public/vlog/guest/like-dislike?vlogSlug=${vlog_slug}`).then(
      (res) => {
        if (!res.error && res.data) {
          const { user } = res.data;
          setCountLike(res.data);
        }
      }
    );
  };

  useEffect(() => {
    setprofileInfo(profileInfos);
    setSystemActions(systemAction);
  }, []);

  useEffect(() => {
    if (vlog_slug && profileInfo) {
      getData();
    } else if (vlog_slug) {
      getGuestData();
    }
  }, [vlog_slug, profileInfo]);

  const apiPost = async (like, disLike) => {
    await API.post("/public/vlog/like-dislike", {
      postId: vlogDetails?.id,
      likeStatus: like ? 1 : 0,
      dislikeStatus: disLike ? 1 : 0,
    }).then(async (res) => {
      if (!res.error) {
        // console.log(res);
        await getData();
      }
    });
  };

  const likeAction = async () => {
    if (disLike) {
      setDisLike(false);
      setLike(true);
      await apiPost(true, false);
    } else {
      setLike(!like);
      await apiPost(!like, disLike);
    }
  };

  const disLikeAction = async () => {
    if (like) {
      setLike(false);
      setDisLike(true);
      await apiPost(false, true);
    } else {
      setDisLike(!disLike);
      await apiPost(like, !disLike);
    }
  };
  let videoUrl;
  if (vlogDetails?.videoType === "vimeo") {
    videoUrl = `https://vimeo.com/${vlogDetails?.embeddedCode}`;
  } else {
    videoUrl = `https://youtu.be/${vlogDetails?.embeddedCode}`;
  }
  const feaureImg = encodeURI(vlogDetails?.featuredImage?.src);
  const thumbnailImg = encodeURI(vlogDetails?.thumbnail?.src);
  return (
    <div>
      <VlogSectionHeading style={{ padding: "200px 0" }} />
      <section>
        <div className="container relative">
          <div className={`${styles.section_wrapper}`}>
            <div className={`${styles.detail_video_wrapper} relative`}>
              <ReactPlayer
                height="100%"
                width="100%"
                className={`${styles.react_player} test`}
                url={videoUrl}
                playing={true}
                controls={true}
                loop={true}
                pip={true}
                playIcon={<PlayButtonWithRipple />}
                light={
                  feaureImg ||
                  thumbnailImg ||
                  "assets/images/video_placeholder_big.png"
                }
              />
            </div>

            <div className={styles.heading_wrapper}>
              <div className={styles.left_wrapper}>
                <div className={styles.title}>{vlogDetails?.title}</div>
                <div className={styles.sub_titile}>
                  {vlogDetails?.totalView} Views ●{" "}
                  {moment(vlogDetails?.publishedDate).format("MMMM DD, YYYY")}
                </div>
              </div>
              <div className={styles.right_wrapper}>
                <div className={styles.like_wrapper}>
                  <div className="relative">
                    <IconButton
                      onClick={() => {
                        if (profileInfo) {
                          likeAction();
                        } else {
                          systemActions.setReturnUrl(router.asPath);
                          return router.push({ pathname: "/signin" });
                        }
                      }}
                      className={`${styles.like_icon} ${
                        like ? styles.like_icon : ""
                      }`}
                    >
                      {/* <div className={`uni-tooltip`}>
                        Please Login <br /> to perform this action
                      </div> */}
                      <AiOutlineLike />
                    </IconButton>
                    <span className={styles.display}>
                      {countLike?.likeCount}
                    </span>
                  </div>

                  <div className={styles.border}>
                    <IconButton
                      onClick={() => {
                        if (profileInfo) {
                          disLikeAction();
                        } else {
                          systemActions.setReturnUrl(router.asPath);
                          return router.push({ pathname: "/signin" });
                        }
                      }}
                      className={`${styles.like_icon} ${
                        disLike ? `${styles.active}` : ""
                      }`}
                    >
                      <AiOutlineDislike />
                    </IconButton>
                    <span className={styles.display}>
                      {countLike?.dislikeCount}
                    </span>
                  </div>
                </div>

                <div className="relative">
                  <SocialSharingLinks
                    className="vlog_socile_wrapper"
                    url={`${baseUrl}/vlog/${vlog_slug}`}
                    title={vlogDetails?.title}
                  />
                </div>
              </div>
            </div>
          </div>

          <Grid container spacing={4} sx={{ mt: 1 }}>
            <Grid item md={9} sm={12} xs={12}>
              {vlogDetails &&
                vlogDetails?.content &&
                htmlParse(vlogDetails?.content)}

              <div className={styles.comment_wrapper}>
                <VlogComment
                  vlogSlug={vlog_slug}
                  referenceId={vlogDetails?.id}
                />
              </div>
            </Grid>

            <Grid item md={3} sm={12} xs={12}>
              <VlogRecommended keyword={keyword} id={vlogDetails.id} />
            </Grid>
          </Grid>
        </div>
      </section>
    </div>
  );
};

export default VlogDetails;
